import { HttpErrorResponse } from '@angular/common/http';
import { EntityState } from '@ngrx/entity';
import { SURVEY_QUESTION_RESPONSE_OPTIONS } from '../../enums/survey-question-response-options.enum';
import { UserSurveyStatus, UserSurveyStatusDto } from '../../interfaces/user-survey-status.interface';
import { SurveySummary } from '../survey-summary.interface';
import { Survey } from '../survey.interface';

export interface ISurveysFeatureState extends EntityState<Survey> {
    activeSurvey: Survey | null;
    openedSurveySummary: SurveySummary;
    currentQuestion: number;
    responses: ISurveyResponses;
    surveyStatus: UserSurveyStatusDto | null;
    isPopupVisible: boolean;
    error: string | null | HttpErrorResponse;
    loading: boolean;
    openedSurvey: Survey | null;
    surveysList: SurveySummary[];
    eligibleUsersSurveyStatus: UserSurveyStatus[];
}

export interface ISurveyResponses {
        question1?: SURVEY_QUESTION_RESPONSE_OPTIONS;
        question2?: string;
        question3?: string;
        question4?: string;
}